import styled from "styled-components";
import { formatDefaultDateTime, formatInteger, formatPercentage } from "../../../../utils/Formatter";

// #region SCOPED CSS
const StyledTooltipReorderCards = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        //padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .reorder-summary {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        width: 100%;
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-1 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-1-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .titles-1-span2 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .frame-1000011432 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011434 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-2 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-weight: 700;
    }
    .titles-2-span2 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .titles-2-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011438 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-3 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-3-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-weight: 700;
    }
    .titles-3-span2 {
        color: var(--buttons-all-platforms-gray-100, #d1d1d1);
    }
    .titles-3-span3 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .frame-1000011439 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011435 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-4 {
        text-align: left;
        font-size: 11px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-4-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-4-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
`;

const StyledTooltipReorderDetails = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        //padding: 6px 10px 6px 10px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        width: 100%;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .title-1 {
        text-align: left;
        position: relative;
        align-self: stretch;
    }
    .title-1-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 12px;
        font-weight: 700;
    }
    .title-1-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 12px;
        font-weight: 400;
    }
    .title-1-span3 {
        color: var(--text-and-icons-green-500, #00bb00);
        font-size: 12px;
        font-weight: 400;
    }
    .frame-1000011432 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-2 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-weight: 700;
    }
    .titles-2-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .titles-2-span3 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .titles-2-span4 {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .frame-1000011442 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011434 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-3-span {
        font-weight: 700;
    }
    .titles-3-span2 {
    }
    .frame-1000011439 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011435 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-4 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-4-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-4-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
`;
// #endregion

export const TooltipReorderCard = ({ data, hasInternalTransfer = false }) => {
    // #region VARIABLES
    const {
        totalBarcodes = "N/A",
        highestPriority = "N/A",
        totalUrgentVariations = "N/A",
        totalProvisionalQuantityNeeded = "N/A",
        totalInternalTransfers = "N/A",
        totalRecommendedQuantity = "N/A",
        //lastUpdateDate
        date = "N/A"
    } = data || {};
    // #endregion

    // #region COMPUTED VALUES
    const formattedDate = formatDefaultDateTime(date, "N/A");
    // #endregion

    // #region RENDER
    return (
        <StyledTooltipReorderCards>
            <div className="styled-tooltip">
                <div className="frame-1000011430">
                    <div className="reorder-summary">Reorder summary</div>
                </div>
                <div className="frame-1000011437">
                    <div className="titles-1">
                        <div>
                            <span className="titles-1-span">Variations included: </span>
                            <span className="titles-1-span2">
                                {totalBarcodes}
                                <br />
                            </span>
                            <span className="titles-1-span">Highest priority: </span>
                            <span className="titles-1-span2">
                                {highestPriority}
                                <br />
                            </span>
                            <span className="titles-1-span">Urgent variations: </span>
                            <span className="titles-1-span2">
                                {totalUrgentVariations}
                                <br />
                            </span>
                            <span className="titles-1-span">Calculated need: </span>
                            <span className="titles-1-span2">{totalProvisionalQuantityNeeded} units</span>
                        </div>
                    </div>
                </div>
                <div className="frame-1000011432 divider" />

                {hasInternalTransfer && (
                    <>
                        <div className="frame-1000011434">
                            <div className="titles-2">
                                <div>
                                    <span className="titles-2-span">
                                        Internal supply check
                                        <br />
                                    </span>
                                    <span className="titles-2-span2">{totalInternalTransfers} </span>
                                    <span className="titles-2-span3">units available from your other stores</span>
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011438">
                            <div className="titles-3">
                                <div>
                                    <span className="titles-3-span">
                                        External need
                                        <br />
                                    </span>
                                    <span className="titles-3-span2">After available internal supply: </span>
                                    <span className="titles-3-span3">{totalRecommendedQuantity}</span>
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011439 divider" />
                    </>
                )}

                <div className="frame-1000011435">
                    <div className="titles-4">
                        <div>
                            <span className="titles-4-span">Source: </span>
                            <span className="titles-4-span2">Latest data. Updated {formattedDate}</span>
                        </div>
                    </div>
                </div>
            </div>
        </StyledTooltipReorderCards>
    );
    // #endregion
};

export const TooltipReorderDetails = ({ data }) => {
    // #region VARIABLES
    const {
        variation = "N/A",
        suggestedQuantity = "N/A",
        salesSpeed = "N/A",
        currentStock = "N/A",
        targetCover = "N/A",
        safetyStockDays = "N/A",
        leadTimeDays = "N/A",
        lifecyclePercentage = "N/A",
        lastUpdateDate
    } = data || {};
    // #endregion

    // #region COMPUTED VALUES
    const formattedDate = formatDefaultDateTime(lastUpdateDate, "N/A");
    const formattedSalesSpeed = formatInteger(salesSpeed, "N/A", true, 1);
    const formattedLifecycle = formatPercentage(lifecyclePercentage, "--");
    // #endregion

    // #region RENDER
    return (
        <StyledTooltipReorderDetails>
            <div className="styled-tooltip">
                <div className="frame-1000011430">
                    <div className="title-1">
                        <span>
                            <span className="title-1-span">
                                Quantity details
                                <br />
                                <br />
                            </span>
                            <span className="title-1-span2">Variation: </span>
                            <span className="title-1-span3">
                                {variation}
                                <br />
                            </span>
                            <span className="title-1-span2">Suggested quantity: </span>
                            <span className="title-1-span3">{suggestedQuantity} units</span>
                        </span>
                    </div>
                </div>
                <div className="frame-1000011432 divider" />
                <div className="frame-1000011437">
                    <div className="titles-2">
                        <span>
                            <span className="titles-2-span">
                                Main factors
                                <br />
                            </span>
                            <span className="titles-2-span2">Sales speed: </span>
                            <span className="titles-2-span3">
                                {formattedSalesSpeed} units/day
                                <br />
                            </span>
                            <span className="titles-2-span2">Current stock: </span>
                            <span className="titles-2-span3">
                                {currentStock} units
                                <br />
                            </span>
                            <span className="titles-2-span2">Target cover: </span>
                            <span className="titles-2-span3">
                                {targetCover} days
                                <br />
                            </span>
                            <span className="titles-2-span4">
                                → Lead time: {leadTimeDays} days
                                <br />→ Safety buffer: {safetyStockDays} days
                                <br />
                            </span>
                            <span className="titles-2-span2">Lifecycle: </span>
                            <span className="titles-2-span3">{formattedLifecycle}% </span>
                            <span className="titles-2-span2">of full-price selling period remaining</span>
                        </span>
                    </div>
                </div>
                <div className="frame-1000011442 divider" />
                <div className="frame-1000011434">
                    <div className="titles-3">
                        <span>
                            <span className="titles-3-span">
                                Reason
                                <br />
                            </span>
                            <span className="titles-3-span2">
                                Stock is below the target cover, there is still enough lifecycle left to replenish, and
                                part of the need can be covered internally.
                            </span>
                        </span>
                    </div>
                </div>
                <div className="frame-1000011439 divider" />
                <div className="frame-1000011435">
                    <div className="titles-4">
                        <span>
                            <span className="titles-4-span">Source: </span>
                            <span className="titles-4-span2">Latest BOstageR data. Updated {formattedDate}</span>
                        </span>
                    </div>
                </div>
            </div>
        </StyledTooltipReorderDetails>
    );
    // #endregion
};
